import authApi from '@api/authApi';
import CrudApi from '@api/crudApi';
import locationApi from '@api/locationApi';
import roleApi from '@api/roleApi';
import userApi from '@api/userApi';
import { Org } from '@models/org';
import service from '@util/service';

export default service(
  'orgApi',
  class OrgApi extends CrudApi<Org> {
    path = 'v1/orgs';
    model = Org;

    override async create(org: Org) {
      const createdOrg = await super.create(org);

      authApi.me.invalidate();

      return createdOrg;
    }

    override async delete(id: string): Promise<void> {
      await super.delete(id);

      roleApi.invalidateAllExcept(id);
      locationApi.invalidateAllExcept(id);
      locationApi.live.invalidate();
      userApi.invalidateAllExcept(id);
      authApi.me.invalidate();
    }
  },
);
